import React from 'react';
import { Editor } from '@tinymce/tinymce-react';

// TinyMCE pour que la variable globale existe
// eslint-disable-next-line no-unused-vars
import tinymce from 'tinymce/tinymce';

// Modèle DOM
import 'tinymce/models/dom/model';

// Thème
import 'tinymce/themes/silver';

// Icônes de la barre d'outils
import 'tinymce/icons/default';

// Styles de l'éditeur (importés directement, Vite handle cela)
import 'tinymce/skins/ui/oxide/skin.min.css';

// Importation des plugins
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/help';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/help/js/i18n/keynav/en';
import 'tinymce/plugins/help/js/i18n/keynav/fr_FR';

// Importation des styles comme texte brut
import contentCss from 'tinymce/skins/content/default/content.min.css?raw';
import contentUiCss from 'tinymce/skins/ui/oxide/content.min.css?raw';

const BundledEditor = (props) => {
  const { init, ...rest } = props;
  
  return (
    <Editor
      init={{
        license_key:'gpl',
        language: 'fr_FR',
        language_url: '/tinymce/langs/fr_FR.js',
        resize: false,
        ...init,
        // Désactiver le chargement normal des skins
        skin: false,
        content_css: false,
        // Injecter les styles comme du texte
        content_style: [contentCss, contentUiCss, init.content_style || ''].join('\n'),
        // Désactiver le branding TinyMCE
        branding: false,
        // Désactiver les avertissements de clé API
        promotion: false,
      }}
      {...rest}
    />
  );
};

export default BundledEditor;
